import { Row } from 'react-table';

export const getParentRow = (row: Row): string => row.id.replace(/\..*/g, '');
